/**
 * Utility function to convert a number of bytes into a localized string that
 * can be easily read. The is beneficial when producing error messages
 * regarding a document/image upload that exceeds the maximum file size.
 * @param bytes bytes amount to be formatted to string
 * @returns localize string formated to show bytes using best unit
 */ var BYTE_MULTIPLIER = 1024;
export var formatBytes = function(bytes, strictLocalize) {
    var _sizeLocalizeFunctions_clampedSizeIndex;
    var sizeLocalizeFunctions = [
        byte,
        kilobyte,
        megabyte,
        gigabyte
    ];
    var sizeIndex = Math.floor(Math.log(bytes) / Math.log(BYTE_MULTIPLIER));
    var clampedSizeIndex = Math.max(0, Math.min(sizeIndex, sizeLocalizeFunctions.length - 1));
    var _sizeLocalizeFunctions_clampedSizeIndex1;
    return Math.floor(bytes / Math.pow(BYTE_MULTIPLIER, clampedSizeIndex)) + ((_sizeLocalizeFunctions_clampedSizeIndex1 = (_sizeLocalizeFunctions_clampedSizeIndex = sizeLocalizeFunctions[clampedSizeIndex]) === null || _sizeLocalizeFunctions_clampedSizeIndex === void 0 ? void 0 : _sizeLocalizeFunctions_clampedSizeIndex.call(sizeLocalizeFunctions, strictLocalize)) !== null && _sizeLocalizeFunctions_clampedSizeIndex1 !== void 0 ? _sizeLocalizeFunctions_clampedSizeIndex1 : "");
};
var byte = function(strictLocalize) {
    return strictLocalize({
        id: "l4ijDX",
        defaultMessage: [
            {
                type: 0,
                value: "Bytes"
            }
        ]
    });
};
var kilobyte = function(strictLocalize) {
    return strictLocalize({
        id: "cW1Lcz",
        defaultMessage: [
            {
                type: 0,
                value: "KB"
            }
        ]
    });
};
var megabyte = function(strictLocalize) {
    return strictLocalize({
        id: "lNbW23",
        defaultMessage: [
            {
                type: 0,
                value: "MB"
            }
        ]
    });
};
var gigabyte = function(strictLocalize) {
    return strictLocalize({
        id: "9mjZAQ",
        defaultMessage: [
            {
                type: 0,
                value: "GB"
            }
        ]
    });
};
